import { Grid } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import { IdentificationDocument } from 'shell/view-models/personal-data';

interface ForeignComponentProps {
  disabled?: boolean;
  values?: IdentificationDocument;
  errors?: FormikErrors<IdentificationDocument>;
  touched?: FormikTouched<IdentificationDocument>;
  onChange: (
    key: keyof IdentificationDocument,
    value: IdentificationDocument[keyof IdentificationDocument]
  ) => void;
}

const ForeignComponent = ({
  disabled,
  values,
  onChange,
  errors,
  touched,
}: ForeignComponentProps): React.ReactElement => {
  return (
    <Grid item xs={12} container spacing={2}>
      <Grid item xs={12} md={6}>
        <PmiTextField
          fullWidth
          aria-label="Luogo di rilascio"
          label="Luogo di rilascio *"
          id="placeForeign"
          type="text"
          value={values?.placeForeign || ''}
          onChange={(event) => onChange('placeForeign', event.target.value)}
          disabled={disabled}
          error={Boolean(errors?.placeForeign) && touched?.placeForeign}
          helperText={errors?.placeForeign}
        />
      </Grid>
    </Grid>
  );
};

ForeignComponent.displayName = 'Foreign component';

const Foreign = memo(ForeignComponent);

export default Foreign;
